"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createCheckedItems", {
    enumerable: true,
    get: function() {
        return createCheckedItems;
    }
});
const _ImmutableMap = require("./ImmutableMap");
function createCheckedItems(iterable) {
    if (iterable === undefined) {
        return _ImmutableMap.ImmutableMap.empty;
    }
    if (_ImmutableMap.ImmutableMap.isImmutableMap(iterable)) {
        return iterable;
    }
    const internalMap = new Map();
    for (const item of iterable){
        if (Array.isArray(item)) {
            internalMap.set(item[0], item[1]);
        } else {
            internalMap.set(item, true);
        }
    }
    return _ImmutableMap.ImmutableMap.dangerouslyCreate_unstable(internalMap);
}
